var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[_c('v-sheet',{ref:"jsonEditorContainer",staticClass:"pa-4",staticStyle:{"height":"400px"},attrs:{"id":"jsonEditor"}}),_c('v-sheet',{staticClass:"d-flex"},[_c('v-spacer'),_c('v-btn',{staticClass:"mr-5",attrs:{"outlined":"","small":"","color":"primary"},on:{"click":_vm.saveConfig}},[_vm._v(" Save ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }